import React from 'react';
import { usePortfolio } from './../Context/PortfolioContext'; // Adjust the path as needed
import './OptimizationApproachDisplay.css';
const OptimizationApproachDisplay = () => {
    const { portfolioData, updateOptimizationMethod } = usePortfolio();
    const { optimizationMethod } = portfolioData;

    const handleApproachChange = (e) => {
        updateOptimizationMethod(e.target.value);
    };

    // Helper function to display specific information for each approach
    const renderApproachInformation = () => {
        switch (optimizationMethod) {
            case 'Monte Carlo Simulation':
                return <><p>Monte Carlo Mean Variance Optimization integrates random sampling to optimize the portfolio by maximizing returns adjusted for variance, emphasizing the balance between risk and reward.</p></>;
            case 'Monte Carlo Simulation Case1':
                // Customize additional information for Maximizing Returns Subject to ESG Constraints
                return <><p>This optimization problem focuses on <b>Maximizing Returns Subject to ESG Constraints</b>, aiming to achieve the highest possible financial returns while ensuring compliance with predetermined ESG standards.</p></>;
            case 'Monte Carlo Simulation Case2':
                // Specifics for Maximizing ESG Score Subject to a Minimum Return
                return <><p>This scenario prioritizes the <b>Maximization of ESG Scores Subject to a Minimum Return</b>, striving to enhance the portfolio's overall ESG profile while securing a specified level of financial return.</p></>;
            case 'Monte Carlo Simulation Case3':
                // Combination of Returns and ESG Scores
                return <><p>This case involves <b>Maximizing a Weighted Combination of Returns and ESG Scores</b>, directly incorporating both financial returns and ESG considerations into the optimization process without specific constraints.</p></>;
            case 'Monte Carlo Simulation Case4':
                // Minimizing Risk with ESG and Return Constraints
                return <><p>This approach focuses on <b>Minimizing Risk Subject to ESG and Return Constraints</b>, aiming to reduce portfolio risk while adhering to minimum thresholds for financial returns and ESG performance.</p></>;
            case 'Black Litterman 1':
                return <>                <>
                <p>This optimization approach, <strong>Black Litterman 1</strong>, incorporates views on Environmental, Social, and Governance (ESG) factors into the portfolio optimization process. Specifically, it uses <strong>ESG workforce</strong> and <strong>ESG strategy</strong> as views.</p>
                <p>The <strong>ESG workforce</strong> view reflects beliefs about how a company's labor practices, employee diversity, and workplace policies might impact its future performance. Similarly, the <strong>ESG strategy</strong> view considers how a company's management of ESG-related risks and opportunities, strategic sustainability initiatives, and corporate governance practices are likely to influence its financial outcomes.</p>
                <p>By integrating these ESG views into the Black-Litterman model, investors can align their portfolios not only with their financial goals but also with their values regarding sustainability and ethical practices, while taking into account their confidence levels in these views.</p>
            </></>
                default:
                return <><p>Please select an optimization approach to see more details.</p></>;
        }
    };

    return (
        <div className="optimization-approach">
            <select value={optimizationMethod || ''} onChange={handleApproachChange} className="approach-selector">

                <option value="Monte Carlo Simulation">Monte Carlo Mean Variance Optimization</option>
                <option value="Monte Carlo Simulation Case1">Maximizing Returns Subject to ESG Constraints</option>
                <option value="Monte Carlo Simulation Case2">Maximizing ESG Score Subject to a Minimum Return</option>
                <option value="Monte Carlo Simulation Case3">Maximizing a Weighted Combination of Returns and ESG Scores</option>
                <option value="Monte Carlo Simulation Case4">Minimizing Risk Subject to ESG and Return Constraints</option>
                <option value="Black Litterman 1">The Black Litterman Method</option>
                {/* Add more optimization approaches as needed */}
            </select>
            
            {optimizationMethod && (
                <div>
                    <p>Selected Approach: <strong>{optimizationMethod}</strong></p>
                    {renderApproachInformation()}
                </div>
            )}
        </div>
    );
};

export default OptimizationApproachDisplay;
